export const CONSENT_STORAGE_KEY = "hp_cookie_consent";

export const CONSENT_UPDATED_EVENT = "hp-cookie-consent-updated";
export const CONSENT_OPEN_SETTINGS_EVENT = "hp-cookie-consent-open-settings";

export const DEFAULT_CONSENT = {
    necessary: true,
    analytics: false,
    advertising: false,
};

const ADSENSE_CLIENT = "ca-pub-4640756756967938";

function pushGtmConsentUpdate(updates) {
    window.dataLayer = window.dataLayer || [];
    if (typeof window.gtag !== "function") {
        function gtag() {
            window.dataLayer.push(arguments);
        }
        window.gtag = gtag;
    }
    window.gtag("consent", "update", updates);
}

function loadAdSense() {
    if (document.querySelector("script[data-hp-adsense]")) {
        return;
    }
    const script = document.createElement("script");
    script.async = true;
    script.src = `https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${ADSENSE_CLIENT}`;
    script.crossOrigin = "anonymous";
    script.dataset.hpAdsense = "true";
    document.head.appendChild(script);
}

export function getStoredConsent() {
    try {
        const raw = localStorage.getItem(CONSENT_STORAGE_KEY);
        if (!raw) {
            return null;
        }
        const parsed = JSON.parse(raw);
        return {
            necessary: true,
            analytics: Boolean(parsed.analytics),
            advertising: Boolean(parsed.advertising),
            updatedAt: parsed.updatedAt || null,
        };
    } catch {
        return null;
    }
}

export function saveConsent(consent) {
    const payload = {
        necessary: true,
        analytics: Boolean(consent.analytics),
        advertising: Boolean(consent.advertising),
        updatedAt: new Date().toISOString(),
    };
    localStorage.setItem(CONSENT_STORAGE_KEY, JSON.stringify(payload));
    applyConsent(payload);
    window.dispatchEvent(new CustomEvent(CONSENT_UPDATED_EVENT, { detail: payload }));
    return payload;
}

export function applyConsent(consent) {
    const analytics = Boolean(consent?.analytics);
    const advertising = Boolean(consent?.advertising);

    pushGtmConsentUpdate({
        analytics_storage: analytics ? "granted" : "denied",
        ad_storage: advertising ? "granted" : "denied",
        ad_user_data: advertising ? "granted" : "denied",
        ad_personalization: advertising ? "granted" : "denied",
    });

    if (advertising) {
        loadAdSense();
    }
}

export function acceptAllConsent() {
    return saveConsent({ necessary: true, analytics: true, advertising: true });
}

export function rejectOptionalConsent() {
    return saveConsent({ necessary: true, analytics: false, advertising: false });
}
